<div
  class="dropdown"
  [ngClass]="!isDeviceMobile ? 'is-right' : ''"
  [class.is-active]="isOpened"
  (keydown.esc)="toggleShow()"
  (portalClickOutside)="clickOutside()"
  data-e2e="exportCsv-dropdown"
>
  <div>
    <button
      class="button is-primary is-outlined has-text-right ml-2"
      (click)="toggleShow()"
      data-e2e="exportCsv-button-open"
      type="button"
      title="{{ buttonText }}"
      [disabled]="newPayloadLoading"
      [attr.aria-label]="buttonText"
    >
      {{ buttonText }}
      <span class="icon ml-2">
        <i [ngClass]="!isOpened ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
      </span>
    </button>
  </div>
  <div class="dropdown-menu" [class.is-wide-popup]="!isDeviceMobile">
    <div class="dropdown-content">
      <div
        class="column is-flex is-justify-content-space-between p-3"
        [class.is-flex-direction-column]="isDeviceMobile"
      >
        <p class="title pt-1" data-e2e="exportCsv-title">{{ titleText }}</p>
      </div>
      <ng-container>
        <ng-container
          *ngIf="
            reportCount <= maximumReportLimit &&
            (exportScreenState.initialScreen || exportScreenState.successScreen)
          "
          [ngTemplateOutlet]="warning"
        ></ng-container>
        <ng-container
          *ngIf="reportCount > maximumReportLimit"
          [ngTemplateOutlet]="notPermit"
        ></ng-container>
        <div class="export-report dropdown-item pt-0">
          <div *ngIf="exportScreenState.loadingScreen" class="label">
            <span data-e2e="exportCsv-types-title" i18n>Report Generating</span>
          </div>

          <div *ngIf="exportScreenState.successScreen" class="label">
            <span data-e2e="exportCsv-types-title" i18n>Report Generated</span>
          </div>

          <div
            *ngIf="exportScreenState.loadingScreen"
            class="is-flex is-justify-content-space-between"
          >
            <portal-spinner [isSmall]="true" text="Report Generating" i18n-text></portal-spinner>
          </div>

          <div *ngIf="exportScreenState.successScreen && exportScreenState?.reportId" class="field">
            <dt class="has-text-grey" i18n>
              Report ID : <span class="has-text-black pr-1">{{ exportScreenState.reportId }}</span>
              <portal-copy-to-clipboard
                [valueToCopy]="exportScreenState.reportId"
                [useNotifierForToast]="true"
                [dataE2eId]="'report-id'"
              ></portal-copy-to-clipboard>
            </dt>
          </div>

          <div
            class="is-flex is-justify-content-space-between"
            [class.is-flex-direction-column]="isDeviceMobile"
          >
            <div class="help">
              <button
                *ngIf="exportScreenState.initialScreen"
                type="button"
                class="button is-text has-text-danger is-transparent"
                (click)="closeSideBar()"
                aria-label="Cancel"
              >
                Cancel
              </button>
              <button
                *ngIf="exportScreenState.loadingScreen || exportScreenState.successScreen"
                type="button"
                [disabled]="exportScreenState.loadingScreen"
                class="button has-text-black"
                (click)="goto()"
                aria-haspopup="true"
                aria-controls="dropdown-menu2"
              >
                <i class="fa-regular fa-arrow-up-right-from-square mr-2"></i>
                <span i18n title="Generated Reports"> Generated Reports </span>
              </button>
            </div>
            <div
              *ngIf="reportCount <= maximumReportLimit"
              class="is-flex"
              [class.is-flex-direction-column]="isDeviceMobile"
            >
              <div
                *ngIf="exportScreenState.loadingScreen || exportScreenState.successScreen"
                class="is-one-quarter py-1 pl-1"
              >
                <button
                  type="button"
                  class="button is-text has-text-danger is-transparent"
                  (click)="closeSideBar()"
                  aria-label="Cancel"
                >
                  Cancel
                </button>
              </div>
              <div class="is-one-quarter py-1 pl-1">
                <div>
                  <button
                    class="button is-primary"
                    (click)="onGenerateReport()"
                    [disabled]="exportScreenState.loadingScreen || exportScreenState.successScreen"
                    data-e2e="generate-button-report"
                    type="button"
                    i18n
                    title="Generate report"
                    i18n-title
                    aria-label="Generate"
                  >
                    Generate
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #warning>
  <div class="pl-2 pr-2 pb-4">
    <div class="notification is-info is-light">
      <div class="icon">
        <i class="far fa-info-circle fa-lg"></i>
      </div>
      <p
        *ngIf="exportScreenState.initialScreen && reportCount <= maximumReportLimit"
        data-e2e="exportCsv-description-warning"
        i18n
      >
        <span class="has-text-weight-semibold">
          Your data set is too large for instant download.
        </span>
        You may generate the report and download it later from the ‘Generated reports’ page. We will
        notify you by email when it is ready.
      </p>

      <p
        *ngIf="exportScreenState.initialScreen && reportCount > maximumReportLimit"
        data-e2e="exportCsv-description-warning"
        i18n
      >
        <span class="has-text-weight-semibold"> Your data set is too large. </span>
        Please reduce the data set by applying filters to narrow the result.
      </p>

      <p *ngIf="exportScreenState.successScreen" data-e2e="exportCsv-description-warning" i18n>
        It may take some additional time for your report to appear in the generated reports page
        depending on the size of your report.
      </p>
    </div>
  </div>
</ng-template>

<ng-template #notPermit>
  <div class="pl-3 pr-3">
    <div class="notification is-danger is-light">
      <p data-e2e="exportCsv-description-warning" i18n>
        <span class="has-text-weight-semibold"> Your data set is too large. </span>
        Please reduce the data set by applying filters to narrow the result.
      </p>
    </div>
  </div>
</ng-template>
